import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { Button, message } from 'antd-v4'
import { IBaseLoyaltyTier } from '@getgreenline/homi-shared'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore/index'
import { WarningFilled } from '@ant-design/icons'
import { COLORS } from '../../../constants/Colors'
import { loyaltyApi } from '@getgreenline/loyalties'
import { parseErrorMsg } from '../../../utilities/helpers'

import './index.scss'
import { DeleteLoyaltySteps } from './DeleteLoyaltyModal'

interface Props {
  onCloseModal: () => void
  loyaltyTier: IBaseLoyaltyTier
  setCurrentStep: (step: DeleteLoyaltySteps) => void
  newLoyaltyTierId: number | undefined
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const DeleteModalConfirmationScreen: React.FC<Props & InjectedProps> = inject(
  'currentCompanyStore',
)(
  observer(
    ({ onCloseModal, loyaltyTier, currentCompanyStore, setCurrentStep, newLoyaltyTierId }) => {
      const loyaltyName = `'${loyaltyTier.name}'`

      const getLoyaltyNameById = (id: number) =>
        currentCompanyStore?.loyaltyTiers?.find((tier) => tier.id === id)?.name || ''

      const onDeleteLoyaltyTier = async () => {
        const companyId = currentCompanyStore?.company?.id

        if (!currentCompanyStore || !companyId) {
          return
        }

        try {
          await loyaltyApi.deleteLoyaltyTier(companyId, loyaltyTier.id, newLoyaltyTierId)
          message.success('Successfully deleted the loyalty tier')
          await currentCompanyStore.getLoyaltyTiers()
          onCloseModal()
        } catch (error) {
          message.error(parseErrorMsg(error) || 'An error occurred while deleting the loyalty tier')
        }
      }

      const confirmationMessage = () => {
        if (loyaltyTier.customerCount === 0) {
          return `Are you sure you want to delete ${loyaltyName} loyalty?`
        }

        if (newLoyaltyTierId) {
          return `You are about to delete the ${loyaltyName} and transferring your customer list to '${getLoyaltyNameById(
            newLoyaltyTierId,
          )}'`
        }

        return `You are about to delete the ${loyaltyName} without transferring your customer list`
      }

      return (
        <div>
          <div className='d-flex align-items-center px-2'>
            <WarningFilled style={{ fontSize: 90, marginTop: 10 }} />
            <div className='pl-4'>
              <strong style={{ fontSize: 17, color: COLORS.red400 }}>
                {confirmationMessage()}
              </strong>
            </div>
          </div>
          <div className='d-flex justify-content-center mt-4'>
            {loyaltyTier.customerCount > 0 && (
              <Button
                className='mr-4 opacity-on-hover'
                type='primary'
                style={{
                  backgroundColor: COLORS.lightBlack,
                  borderColor: 'transparent',
                  width: 150,
                  fontSize: 17,
                }}
                onClick={() => setCurrentStep(DeleteLoyaltySteps.TRANSFER)}
              >
                Go back
              </Button>
            )}

            <Button
              className='opacity-on-hover'
              type='primary'
              style={{
                backgroundColor: COLORS.red400,
                borderColor: COLORS.red400,
                width: 150,
                fontSize: 17,
              }}
              onClick={onDeleteLoyaltyTier}
            >
              Delete
            </Button>
          </div>
        </div>
      )
    },
  ),
)
